export enum AppRoutes {
  Folders = 'folders',
  Files = 'files',
  Users = 'users',
  Downloads = 'downloads',
  Dashboard = 'dashboard',
  Shared = 'shared',
  Videos = 'videos',
  Customers = 'customers',
  Live = 'live',
  Devices = 'devices',
  OrganizationChart = 'org-chart',
  Categories = 'categories',
  Events = 'events',
  Reports = 'reports',
}
